import { TICKET_DETAILS, STATUS_LIST, CHANGE_STATUS } from "./type";

const initalState = {
    ticketDetails: null,
    statusList: [],
    changeStatus: null,
};

const ticketDetailsReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case TICKET_DETAILS:
            return {
                ...state,
                ticketDetails: payload,
            };

        case STATUS_LIST:
            return {
                ...state,
                statusList: payload,
            };

        case CHANGE_STATUS:
            return {
                ...state,
                changeStatus: payload,
            };

        default:
            return {
                ...state,
            };
    }
};

export default ticketDetailsReducer;
